import {FeaturesEnum} from './featuresFlagEnum';
import {ProductEnum} from './productEnum';

export const FACIAL_BIOMETRIC_FEATURE_BY_HOST = {
	[ProductEnum.HAP]: FeaturesEnum.PORTAL_FEATURE_FACIAL_BIOMETRIC_HAP,
	[ProductEnum.CCG]: FeaturesEnum.PORTAL_FEATURE_FACIAL_BIOMETRIC_CCG,
	[ProductEnum.CLINIPAM]: FeaturesEnum.PORTAL_FEATURE_FACIAL_BIOMETRIC_CLINIPAM,
	[ProductEnum.GNDI_MINAS]: FeaturesEnum.PORTAL_FEATURE_FACIAL_BIOMETRIC_NDIMINAS,
	[ProductEnum.GNDI]: FeaturesEnum.PORTAL_FEATURE_FACIAL_BIOMETRIC_NDISP,
	[ProductEnum.NOTREDAME_SAUDE]: FeaturesEnum.PORTAL_FEATURE_FACIAL_BIOMETRIC_NDISP,
};
